import {getConfig} from '../system/support/helpers';

export default {
    /**
     * The base api url
     */
    apiUrl: getConfig('REACT_APP_API_URL', 'http://localhost'),

    projectName: "Inventory Management"
};
